import { TextField } from '@seeqdev/qomponents';
import type { StyleXStyles } from '@stylexjs/stylex';
import type React from 'react';
import type { FormControlElement } from '@seeqdev/qomponents';

export interface DateTimePickerInputProps {
  ref?: React.Ref<HTMLInputElement>;
  testId?: string;
  placeholder?: string;
  showError?: boolean;
  extraClassNames?: string;
  xstyle?: StyleXStyles;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

interface DefaultDateTimePickerInputProps extends DateTimePickerInputProps {
  inputWidth?: number;
  inputHeight?: number;
}

export const DefaultDateTimePickerInput = ({
  ref,
  testId,
  placeholder,
  showError,
  extraClassNames,
  xstyle,
  inputWidth,
  inputHeight,
  onFocus,
  onChange,
  onBlur,
  onKeyDown,
}: DefaultDateTimePickerInputProps) => (
  <TextField
    ref={ref}
    testId={`${testId}_dateTimePickerInput`}
    placeholder={placeholder}
    showError={showError}
    extraClassNames={extraClassNames}
    xstyle={xstyle}
    inputWidth={inputWidth}
    inputHeight={inputHeight}
    onFocus={onFocus}
    onChange={onChange as React.ChangeEventHandler<FormControlElement> | undefined}
    onBlur={onBlur as React.FocusEventHandler<FormControlElement> | undefined}
    onKeyDown={onKeyDown as React.KeyboardEventHandler<FormControlElement> | undefined}
  />
);
